import configureStore from './configure';
import InitialState from './InitialState';
import { persistStore } from 'redux-persist';
// Import your notes reducer
import notesReducer from './Notes/Reducer'; 

// Depending on how your configureStore is built, 
// you may need to pass the combined reducers here.
// Assuming your configureStore takes a rootReducer or allows preloaded state:

const store = configureStore(InitialState);

// If your configureStore does not automatically include the new reducer,
// you might need to inject it or update the root reducer inside ./configure
const persistor = persistStore(store);

export { store, persistor };